import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchBoxConfig } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { OspSearchResultModel } from '../model/osp-search-result.model';
import { OspCategoriesService } from '../services/osp-categories.service';

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  maxProducts: 5,
};

@Component({
    selector: 'app-custom-content-search-result',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-content-search-result.component.html',
    styleUrls: ['./custom-content-search-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomContentSearchResultComponent implements OnInit, OnDestroy {
  query: string;
  resultPresent = false;
  searchResult: OspSearchResultModel;
  ospScriptElement: HTMLScriptElement;
  routeSub: Subscription;
  contentSub: Subscription;

  constructor(
    private readonly ospService: OspCategoriesService,
    private readonly route: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.ospScriptElement = document.createElement('script');
    this.ospScriptElement.src = 'scripts/osp-jquery.js';
    document.body.appendChild(this.ospScriptElement);

    this.routeSub = this.route.queryParams.subscribe((params) => {
      this.query = params.query;
      this.updateData();
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.contentSub?.unsubscribe();
  }

  private updateData() {
    this.ospService.findContentItems(this.query, DEFAULT_SEARCH_BOX_CONFIG);
    this.contentSub = this.ospService.contentItemsSearchResult$.subscribe(
      (res) => {
        if (res != null) {
          this.resultPresent = res.products.length > 0;
          this.searchResult = res;
          this.changeDetectorRef.detectChanges();
        } else {
          this.resultPresent = false;
          this.changeDetectorRef.detectChanges();
        }
      }
    );
  }

  toggleAccordion(item: any) {
    item.selected = !item.selected;
    this.changeDetectorRef.detectChanges();
  }

  showHeading(documents) {
    let isShown: boolean = false;
    if (isShown) return;
    if (documents) {
      documents.forEach((el) => {
        if (
          el?.type === 'PDF' ||
          el?.type === 'YOUTUBE_VIDEO' ||
          el?.type === 'VIDEO'
        ) {
          isShown = true;
        } else {
          isShown = false;
        }
      });
    }
    return isShown;
  }
}
